if (window.Coupons == null) {
  window.Coupons = {};
}

$(function() {
  return Coupons.popAffiliateLink = function(couponModalUrl, affiliateUrl) {
    window.open(couponModalUrl, '_blank');
    window.location.assign(affiliateUrl, "_blank");
    return false;
  };
});

